import { AxiosError } from 'axios';
import instance from '../config/axios';
import {
  DoctorAndProductsResponse,
  PatientDetailResponse,
} from '../interface/interface';

export const getPatientDetails = async (
  id: string,
  filter: string,
  accessToken: string,
): Promise<number | PatientDetailResponse> => {
  try {
    const response = await instance({
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      url: `/api/v1/patient-details/${id}?filter=${filter}`,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status as number;
  }
};

export const getPatientCredits = async (
  patientEmail: string,
  access_token?: string,
): Promise<number> => {
  try {
    const response = await instance({
      url: `/api/v1/patient/storecredits/${patientEmail}`,
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      method: 'GET',
    });

    return response.data?.balance ?? 0;
  } catch (err) {
    console.error(err);

    return 0;
  }
};

export const updatePatientData = async (
  accessToken: string,
  data: Record<any, any>,
): Promise<number> => {
  try {
    const response = await instance({
      url: '/api/v1/update/patient',
      method: 'PUT',
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response?.status as number;
  }
};

export const fetchDoctorAndProducts = async (
  accessToken: string,
): Promise<DoctorAndProductsResponse | number> => {
  try {
    const response = await instance({
      method: 'GET',
      url: '/api/v1/doctor-products',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (e) {
    console.log('Error while fetching products and doctors', e);
    return (e as AxiosError).response?.status as number;
  }
};

export const updatePrescriptionStatus = async (
  accessToken: string,
  payload: { prescripionId: number; staus: string },
): Promise<number> => {
  try {
    const response = await instance({
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      method: 'PUT',
      url: '/api/v1/update-prescription-status',
      data: { id: payload.prescripionId, status: payload.staus },
    });

    return response.status;
  } catch (e) {
    console.log('Unable to update prescription', e);
    return (e as AxiosError).response?.status as number;
  }
};

export const updatePrescriptionList = async (
  accessToken: string,
  data: any,
) => {
  try {
    const response = await instance({
      method: 'PUT',
      url: '/api/v1/patient/prescription/update',
      data,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.status;
  } catch (e) {
    console.log('Unable to update prescription list', e);
    return (e as AxiosError).response?.status;
  }
};

export const enableOrDisableOrder = async (
  accessToken: string,
  data: { patientId: number; allowedToOrder: boolean },
) => {
  try {
    const response = await instance({
      url: '/api/v1/patient/order/allow',
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data,
    });

    return response.status;
  } catch (e) {
    console.log('Unable to manageOrderStatus', e);
    return (e as AxiosError).response?.status;
  }
};

export const onboardExistingTokens = async (
  accessToken: string,
  patientIdList: number[],
) => {
  try {
    const response = await instance({
      url: '/api/v1/patient/onboard/existing',
      method: 'POST',
      data: { patientList: patientIdList },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response.status;
  } catch (e) {
    console.log('Unable to onboardExising tokens', e);
    return (e as AxiosError).response?.status;
  }
};

export const updatePrescriptionPreferable = async (
  prescriptionId: number,
  preferable: boolean,
  accessToken: string,
) => {
  try {
    const response = await instance.put(
      '/api/v1/prescription/update/isPreferable',
      {
        id: prescriptionId,
        isPreferable: preferable,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return response.status;
  } catch (e) {
    console.log('Unable to onboardExising tokens', e);
    return (e as AxiosError).response?.status;
  }
};
